<template lang="pug">
v-app
  section.position-relative
    header.d-flex.row.flex-row.align-items-end
      .col
        router-link.button-previous.mr-2(to="/seguimiento-diario/id")
          i.fas.fa-chevron-left
        h2.m-0.d-inline-block.align-middle
          i {{$route.name}} 
        br
        br
        div(v-for="usr in user.users")
          h1.d-inline-block.m-0.text-capitalize
            i {{usr.name}}
        br
        //- h3.d-inline-block.m-0.text-capitalize
        //-   i   KPI Personal: {{user.personal_kpi}}%
      //- .d-flex.row.flex-row.align-items-end
      .col-6
        .card.ad_border1-secondary.rounded-xl
          h4
            i Objetivos
              .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-for="(objective, index) in user.objectives")
                form
                  .d-flex.row.form-group.align-items-end.mb-1
                    .col
                      label
                        a(:id="'viaje' + index")
                          i.icon-letters.icon-letters__viaje(v-if="objective.travel") V
                          i.icon-letters.icon-letters__producto.mx-1(v-if="objective.product") P
                          i.icon-letters.icon-letters__segmento(v-if="objective.segment") S
                        b-tooltip(:target="'viaje' + index" , placement='top')
                          | {{objective.travel ? objective.travel.name : ''}} + {{objective.product ? objective.product.name : ''}} + {{objective.segment ? objective.segment.name : ''}}
                      label.ml-2
                        a(:id="'kpineg' + index")
                          i.icon-letters.icon-letters__negocio.mr-1 N
                        b-tooltip(:target="'kpineg' + index", placement="top")
                          | {{objective.business_type.name}}
                        | {{ objective.kpi ? objective.kpi.name : ''}}
                      label.ml-2
                        div.px-0.justify-content-center.text-info
                          | {{objective.open ? "Libre" : ""}}

    section.mt-5
      .d-flex.row.mx-0.ad_border1-secondary.rounded-xl.overflow-hidden
        .col-12.px-0
          .card.border-0.mb-0.position-relative(:class="{'off-position' : !problemas}")
            .row.d-flex.align-items-top.py-2
              .col
                h3.ad_text-primary
                  i Problemas & Oportunidades 
                h4.ad_text-secondary
                  i Detección de Problemas* 
                  small (Obligatorio)
              .col-auto
                button.ad_text-primary(@click="problemas = !problemas" :class="{'chevron-up' : !problemas}")
                  span.text-bold.font-italic Ver 
                    em(v-if="!problemas")  menos
                    em(v-if="problemas")  más
                  i.fas.fa-chevron-down.ad_text-primary.ml-1
              .col-12
                p.mb-1 
                  | Considerando los indicadores con bajo cumplimiento, ¿Existe algún problema que te ha impedido realizar correctamente tu trabajo y no cumplir con las metas definidas?
                h4
                  small Ej. Herramientas, Materiales, Camioneta, Procedimientos, Clientes. Se pide describir el problema para poder tomar acciones sobre ellos y solicitar al técnico que entregue evidencias que demuestren la ocurrencia de estos problemas.
              
            .row.d-flex.align-items-center
              .col-auto.pr-1
                label.m-0 Nuevo
              .col.px-1
                input.form-control(v-model="problem.description" type="text" placeholder="Descripción")
              .col-2.px-1
                .ad_select
                  select(v-model='pClasificacion')
                    option(:value="null" disabled) Clasificación
                    option(:value="clasif", v-for="clasif in clasificacion") {{clasif}}

              .col-3.px-1
                .ad_select
                  select(v-model='pResponsable')
                    option(:value="null" disabled) Responsable
                    option(:value="colab", v-for="colab in responsables") {{colab.name}}
      
              .col-2.px-1.position-relative
                v-menu(ref='problemDate', v-model='problemDate', :close-on-content-click='true', :nudge-right='40', :return-value.sync='date', lazy, transition='scale-transition', offset-y='', full-width, min-width='290px')
                  v-text-field.date-input(slot='activator', v-model='problem.date', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                  v-date-picker(v-model='problem.date', no-title='', scrollable='' locale="es", @input="menu2 = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")
              .col-auto
                button.ad_bg-success.btn-icon(type="button", @click="newProblem()")
                  i.fas.fa-plus.rounded-circle 
          
          .col.collapsible.ad_bg-gray.rounded-0.px-0(:class="{'collapsed' : problemas}")
            .card-body
              .row
                .col
                  h3.ad_text-danger 
                    i Pendientes
                  p.text-center.ad_text-grayLight.font-italic(v-if="listProblem.pendientes == ''")
                    | Aún no tienes Detección de Problemas pendientes
                  table.w-100.text-left.table-rounded-body(v-if="listProblem.pendientes != ''")
                    thead
                      tr
                        th Descripción
                        th Clasificación
                        th Responsable
                        th Fecha de ingreso
                        th Semana
                        th(width="50")
                        th(width="80")
                    tbody
                      tr(v-for="op in listProblem.pendientes")
                        td
                          div.py-2
                            | {{ op.description }}
                        td
                          div
                            | {{ op.clasification }}
                        td
                          div
                            | {{ op.responsible.name }}
                        td
                          div
                            | {{moment(op.date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-success(v-if="moment() < moment(op.date)")
                              | {{ moment().format('W') - moment(op.date).format('W') === 0 ? 1 : moment().format('W') - moment(op.date).format('W') }}&deg; sem
                            span.ad_text-warning(v-if="moment() === moment(op.date)")
                              | {{ moment().format('W') - moment(op.date).format('W')  }}&deg; sem
                            span.ad_text-danger(v-if="moment() > moment(op.date)")
                              | {{ moment().format('W') - moment(op.date).format('W') }}&deg; sem
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(op._id, 'problem')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn.btn-secondary.px-3(@click="openCloseModal(op._id, 'problem', op)")
                              | Cerrar
              .row.mt-4
                .col
                  h3.ad_text-success 
                    i Nuevos
                  p.text-center.ad_text-grayLight.font-italic(v-if="listProblem.nuevos == ''")
                    | Aún no tienes Detección de Problemas nuevos
                  table.w-100.text-left.table-rounded-body(v-if="listProblem.nuevos != ''")
                    thead
                      tr
                        th Descripción
                        th Clasificación
                        th Responsable
                        th(width="50")
                        th(width="50")
                    tbody
                      tr(v-for="op in listProblem.nuevos")
                        td
                          div.py-2
                            | {{ op.description }}
                        td
                          div
                            | {{ op.clasification }}
                        td
                          div
                            | {{ op.responsible.name }}
                        td.text-right
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(op._id, 'problem')")
                              i.icono.icono-comentarios.ad_text-primary
                        td.text-right
                          div
                            a.btn-icon.ad_bg-secondary.border-btnicon-secondary(@click="removeProblem('problem', op._id)")
                              i.fas.fa-times.rounded-circle.text-white
          hr
        .col-12.px-0
          .card.border-0.mb-0.position-relative(:class="{'off-position' : !oportunidades}")
            .row.d-flex.align-items-top.py-2
              .col
                h3.ad_text-primary
                  i Problemas & Oportunidades 
                h4.ad_text-secondary
                  i Oportunidades de mejora* 
                  small (Obligatorio)
              .col-auto
                button.ad_text-primary(@click="oportunidades = !oportunidades" :class="{'chevron-up' : !oportunidades}")
                  span.text-bold.font-italic Ver 
                    em(v-if="!oportunidades")  menos 
                    em(v-if="oportunidades")  más 
                  i.fas.fa-chevron-down.ad_text-primary.ml-1
              .col-12
                p.mb-1 
                  | Considerando la respuesta anterior, ¿crees que se debe realizar alguna modificación en el procedimiento que te permita mejorar tu desempeño y entregar un mejor servicio a nuestros clientes?
                h4
                  small 
                    | Anotar las oportunidades de mejora, solicitar al técnico que entregue evidencia de casos que demuestren las malas prácticas o problemas asociadas a estas mejoras propuestas.
              
            .row.d-flex.align-items-center
              .col-auto.pr-1
                label.m-0 Nuevo
              .col.px-1
                input.form-control(v-model="oportunity.description" type="text" placeholder="Descripción")
              .col-2.px-1
                .ad_select
                  select(v-model='oClasificacion')
                    option(:value="null" disabled) Clasificación
                    option(:value="clasif", v-for="clasif in clasificacion") {{clasif}}

              .col-3.px-1
                .ad_select
                  select(v-model='oResponsable')
                    option(:value="null" disabled) Responsable
                    option(:value="colab", v-for="colab in responsables") {{colab.name}}
                          
              .col-2.px-1.position-relative
                v-menu(ref='oportunityDate', v-model='oportunityDate', :close-on-content-click='true', :nudge-right='40', :return-value.sync='date', lazy, transition='scale-transition', offset-y='', full-width, min-width='290px')
                  v-text-field.date-input(slot='activator', v-model='oportunity.date', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                  v-date-picker(v-model='oportunity.date', no-title='', scrollable='' locale="es", @input="menu2 = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")
              .col-auto
                button.ad_bg-success.btn-icon(type="button", @click="newOportunity()")
                  i.fas.fa-plus.rounded-circle 
      .col.collapsible.ad_bg-gray.mt--3.px-0(:class="{'collapsed' : oportunidades}")
        .card-body
          .row
            .col
              h3.ad_text-danger 
                i Pendientes
              p.text-center.ad_text-grayLight.font-italic(v-if="listOportunities.pendientes == ''")
                | Aún no tienes Oportunidades de mejora pendientes
              table.w-100.text-left.table-rounded-body(v-if="listOportunities.pendientes != ''")
                thead
                  tr
                    th Descripción
                    th Clasificación
                    th Responsable
                    th Fecha de ingreso
                    th Semana
                    th(width="50")
                    th(width="80")
                tbody
                  tr(v-for="op in listOportunities.pendientes")
                    td
                      div.py-2
                        | {{ op.description }}
                    td
                      div
                        | {{ op.clasification }}
                    td
                      div
                        | {{ op.responsible.name }}
                    td
                      div
                        | {{moment(op.date).utc().format("DD/MM/YYYY")}}
                    td
                      div
                        span.ad_text-success(v-if="moment() < moment(op.date)")
                          | {{ moment().format('W') - moment(op.date).format('W') === 0 ? 1 : moment().format('W') - moment(op.date).format('W') }}&deg; sem
                        span.ad_text-warning(v-if="moment() === moment(op.date)")
                          | {{ moment().format('W') - moment(op.date).format('W')  }}&deg; sem
                        span.ad_text-danger(v-if="moment() > moment(op.date)")
                          | {{ moment().format('W') - moment(op.date).format('W') }}&deg; sem
                    td
                      div
                        a.no-decoration(title="Comentarios" @click="getComments(op._id, 'problem')")
                          i.icono.icono-comentarios.ad_text-primary
                    td
                      div
                        a.btn.btn-secondary.px-3(@click="openCloseModal(op._id, 'problem', op)")
                          | Cerrar
          .row.mt-4
            .col
              h3.ad_text-success 
                i Nuevos
              p.text-center.ad_text-grayLight.font-italic(v-if="listOportunities.nuevos == ''")
                | Aún no tienes Oportunidades de mejora nuevos
              table.w-100.text-left.table-rounded-body(v-if="listOportunities.nuevos != ''")
                thead
                  tr
                    th Descripción
                    th Clasificación
                    th Responsable
                    th(width="50")
                    th(width="50")
                tbody
                  tr(v-for="op in listOportunities.nuevos")
                    td
                      div.py-2
                        | {{ op.description }}
                    td
                      div
                        | {{ op.clasification }}
                    td
                      div
                        | {{ op.responsible.name }}
                    td.text-right
                      div
                        a.no-decoration(title ="Comentarios" @click="getComments(op._id, 'problem')")
                          i.icono.icono-comentarios.ad_text-primary
                    td.text-right
                      div
                        a.btn-icon.ad_bg-secondary.border-btnicon-secondary(@click="removeProblem('oport', op._id)")
                          i.fas.fa-times.rounded-circle.text-white
                      
      .d-flex.row
        .col-12
          .card.ad_border1-secondary.rounded-xl.mb-0.mt-4.position-relative(:class="{'off-position' : !compromisocolab}")
            .row.d-flex.align-items-end
              .col
                h3.ad_text-primary
                  i Compromisos colaborador 
              .col-auto
                button.ad_text-primary(@click="compromisocolab = !compromisocolab" :class="{'chevron-up' : !compromisocolab}")
                  span.text-bold.font-italic Ver 
                    em(v-if="!compromisocolab")  menos 
                    em(v-if="compromisocolab")  más 
                  i.fas.fa-chevron-down.ad_text-primary.ml-1
              .col-12
                p.mb-1 
                  | ¿Existe algo en lo que tú te puedas comprometer a hacer distinto para lograr un mejor desempeño en tu trabajo y así aumentar tus indicadores de gestión?
                h4
                  small 
                    | Anotar las los compromisos que el técnico declare para lograr el objetivo planteado, definiendo metas y plazos medibles en el/los próximo/s <b>Seguimiento Diario</b>.
              
            .row.d-flex.align-items-center
              .col-auto.pr-1
                label.m-0 Nuevo
              .col
                input.form-control(v-model="commitment.description" type="text" placeholder="Descripción")
              .col-2.px-1.position-relative

                v-menu(ref='collabDate', v-model='collabDate', :close-on-content-click='true', :nudge-right='40', :return-value.sync='date', lazy, transition='scale-transition', offset-y='', full-width, min-width='290px')
                  v-text-field.date-input(slot='activator', v-model='commitment.date', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                  v-date-picker(v-model='commitment.date', no-title='', scrollable='' locale="es", @input="menu2 = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")
              .col-auto
                button.ad_bg-success.btn-icon(type="button", @click="addCommitmentToCollab()")
                  i.fas.fa-plus.rounded-circle 
          
          .col.collapsible.ad_bg-gray.px-0.mt--3(:class="{'collapsed' : compromisocolab}")
            .card-body
              .row
                .col
                  h3.ad_text-danger 
                    i Pendientes
                  p.text-center.ad_text-grayLight.font-italic(v-if="listUserCommitments.pendientes == ''")
                    | Aún no tienes Compromisos de Colaborador pendientes
                  table.w-100.text-left.table-rounded-body(v-if="listUserCommitments.pendientes != ''")
                    thead
                      tr
                        th(width="50%") Compromiso
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        th(width="80") Semana
                        th(width="40")
                        th(width="100")
                    tbody
                      tr(v-for="pendiente in listUserCommitments.pendientes")
                        td
                          div.py-2
                            | {{ pendiente.description }}
                        td
                          div
                            | {{moment(pendiente.date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(pendiente.scheduled).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-success(v-if="moment() < moment(pendiente.scheduled)")
                              | {{ moment().format('W') - moment(pendiente.scheduled).format('W') === 0 ? 1 : moment().utc().format('W') - moment(pendiente.date).utc().format('W') }}&deg; sem
                            span.ad_text-warning(v-if="moment() === moment(pendiente.scheduled)")
                              | {{ moment().utc().format('W') - moment(pendiente.scheduled).utc().format('W')  }}&deg; sem
                            span.ad_text-danger(v-if="moment() > moment(pendiente.scheduled)")
                              | {{ moment().utc().format('W') - moment(pendiente.scheduled).utc().format('W') }}&deg; sem
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(pendiente._id, 'commitment')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn.btn-secondary.px-3(@click="openCloseModal(pendiente._id, 'collabCommitment', pendiente)")
                              | Cerrar                     
              .row.mt-4
                .col
                  h3.ad_text-success 
                    i Nuevos
                  p.text-center.ad_text-grayLight.font-italic(v-if="listUserCommitments.nuevos == ''")
                    | Aún no tienes Compromisos de Colaborador nuevos
                  table.w-100.text-left.table-rounded-body(v-if="listUserCommitments.nuevos != ''")
                    thead
                      tr
                        th(width="50%") Compromiso
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        th Sem.
                        th(width="80")
                        th(width="50")
                    tbody
                     tr(v-for="nuevo in listUserCommitments.nuevos")
                        td
                          div.py-2
                            | {{ nuevo.description }}
                        td
                          div
                            | {{moment(nuevo.date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(nuevo.scheduled).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-success
                              |  1&deg; sem
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(nuevo._id, 'commitment')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn-icon.ad_bg-secondary.border-btnicon-secondary(@click="removeCommit('user', nuevo._id)")
                              i.fas.fa-times.rounded-circle.text-white     

        .col-12
          .card.ad_border1-secondary.rounded-xl.mb-0.mt-4.position-relative(:class="{'off-position' : !compromisolider}")
            .row.d-flex.align-items-end
              .col
                h3.ad_text-primary
                  i Compromisos Líder
              .col-auto
                button.ad_text-primary(@click="compromisolider = !compromisolider" :class="{'chevron-up' : !compromisolider}")
                  span.text-bold.font-italic Ver 
                    em(v-if="!compromisolider")  menos
                    em(v-if="compromisolider")  más
                  i.fas.fa-chevron-down.ad_text-primary.ml-1
              .col-12
                p.mb-1 
                  | En este compromiso de mejora que definiste, ¿Cómo puedo apoyarte yo desde mi rol de supervisor para lograr cumplir con lo planteado y mejorar tu desempeño?
                h4
                  small 
                    | Anotar los compromisos que puedas como supervisor asumir para lograr el objetivo planteado, definiengdo metas y plazos medibles en el/los próximo/s <b>Seguimiento Diario.</b>

            .row.d-flex.align-items-center
              .col-auto.pr-1
                label.m-0 Nuevo
              .col
                input.form-control(v-model="leaderCommitment.description" type="text" placeholder="Descripción")
              .col-2.px-1.position-relative

                v-menu(ref='leaderDate', v-model='leaderDate', :close-on-content-click='true', :nudge-right='40', :return-value.sync='date', lazy, transition='scale-transition', offset-y='', full-width, min-width='290px')
                  v-text-field.date-input(slot='activator', v-model='leaderCommitment.date', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                  v-date-picker(v-model='leaderCommitment.date', no-title='', scrollable='' locale="es", @input="menu2 = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")
              .col-auto
                button.ad_bg-success.btn-icon(type="button", @click="addCommitmentToLeader()")
                  i.fas.fa-plus.rounded-circle 
          
          .col.collapsible.ad_bg-gray.px-0.mt--3(:class="{'collapsed' : compromisolider}")
            .card-body
              .row
                .col
                  h3.ad_text-danger 
                    i Pendientes
                  p.text-center.ad_text-grayLight.font-italic(v-if="listLeaderCommitments.pendientes == ''")
                    | Aún no tienes Compromisos de Líder pendientes
                  table.w-100.text-left.table-rounded-body(v-if="listLeaderCommitments.pendientes != ''")
                    thead
                      tr
                        th(width="50%") Compromiso
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        th(width="80") Semestre
                        th(width="40")
                        th(width="100")
                    tbody
                      tr(v-for="pendiente in listLeaderCommitments.pendientes")
                        td
                          div.py-2
                            | {{ pendiente.description }}
                        td
                          div
                            | {{moment(pendiente.date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(pendiente.scheduled).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-success(v-if="moment() < moment(pendiente.scheduled)")
                              | {{ moment().format('W') - moment(pendiente.scheduled).format('W') === 0 ? 1 : moment().format('W') - moment(pendiente.date).format('W') }}&deg; sem
                            span.ad_text-warning(v-if="moment() === moment(pendiente.scheduled)")
                              | {{ moment().format('W') - moment(pendiente.scheduled).format('W')  }}&deg; sem
                            span.ad_text-danger(v-if="moment() > moment(pendiente.scheduled)")
                              | {{ moment().format('W') - moment(pendiente.scheduled).format('W') }}&deg; sem
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(pendiente._id, 'commitment')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn.btn-secondary.px-3(@click="openCloseModal(pendiente._id, 'leaderCommitment', pendiente)")
                              | Cerrar                   
              .row.mt-4
                .col
                  h3.ad_text-success 
                    i Nuevos
                  p.text-center.ad_text-grayLight.font-italic(v-if="listLeaderCommitments.nuevos == ''")
                    | Aún no tienes Compromisos de Líder nuevos
                  table.w-100.text-left.table-rounded-body(v-if="listLeaderCommitments.nuevos != ''")
                    thead
                      tr
                        th(width="50%") Compromiso
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        th Sem.
                        th(width="80")
                        th(width="50")
                    tbody
                     tr(v-for="nuevo in listLeaderCommitments.nuevos")
                        td
                          div.py-2
                            | {{ nuevo.description }}
                        td
                          div
                            | {{moment(nuevo.date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(nuevo.scheduled).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-success
                              |  1&deg; sem
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(nuevo._id, 'commitment')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn-icon.ad_bg-secondary.border-btnicon-secondary(@click="removeCommit('leader', nuevo._id)")
                              i.fas.fa-times.rounded-circle.text-white

      .d-flex.row.flex-row.mt-4
        .col-12.text-right
          button.btn.btn-primary.py-2.px-5(@click="closeSD()")
            em Finalizar_
  
    v-navigation-drawer(v-model='commenting', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      .col-12.mt-4
        .form-group.mt-4
          textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
        .form-group.justify-content-between
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="commenting = false")
            i.far.fa-times-circle.fa-1x.mr-1.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="createComment(comment)")
            | Agregar comentario
            i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom

        hr.my-4
      
        h3.ad_text-grayMedio.mb-3
          i Anteriores
        div(v-for="comment in comments")    
          .row.mb-3
            .col-4.pr-0
              p.font-weight-bold.m-0 {{ comment.user }}
              small.d-block {{ moment(comment.creation_date).utc().format("DD/MM/YYYY") }}
              small.d-block {{ moment(comment.creation_date).utc().format('LT') }}
            .col-8.pl-0
              .dialog-box 
                p {{ comment.description }} 


  v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
    header.ad_bg-primary.pt-5.pb-2.px-4
      h3.text-white.mt-4
        i Cerrar Compromiso Colaborador
    section.py-4.px-2.overflowy-auto
      .col.d-flex.flex-nowrap
        p {{ item.description }}
      .d-flex.flex-row
        .col-5
          c-form-radio.ad_radio.ad_radio-cumple(name="cumplimiento" v-model="cumplimiento" value="true" label="Cumple")
          c-form-radio.ad_radio.ad_radio-nocumple(name="cumplimiento" v-model="cumplimiento" value="false" label="No cumple")
      .col-12.mt-4
        .form-group.justify-content-between
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
            i.far.fa-times-circle.fa-1x.mr-1.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="closeItem()")
            | Cerrar compromisos
            i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
        
        hr.my-4
        
        h3.ad_text-grayMedio.mb-3
          i Comentarios
        div(v-for="comment in item.comments")
          .row.mb-3
            .col-4.pr-0
              p.font-weight-bold.m-0 {{ comment.user }}
              small.d-block {{ moment(comment.creation_date).utc().format("DD/MM/YYYY") }}
              small.d-block {{ moment(comment.creation_date).utc().format('LT') }}
            .col-8.pl-0
              .dialog-box
                p {{ comment.description }} 

</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment-timezone'
import Flatpickr from 'vendors/cover/vendors/flatpickr'
import { mapActions } from 'vuex'

export default {

  name: 'SeguimientoDiarioEjecutar',
  components: {
     Multiselect,
     Flatpickr
  },
  data () {
    return {
      pResponsable: null,
      pClasificacion: null,
      oResponsable: null,
      oClasificacion: null,
      cumplimiento: '',
      drawer: null,
      commenting: null,
      collabDate: false,
      leaderDate: false,
      personalDate: false,
      oportunityDate: null,
      problemDate: null,
      menu: false,
      date: null,
      user: { S: {}, P: {}, ica: [], kpipercentage: [] },
      team: [],
      accountable: null,
      commitment: {},
      leaderCommitment: {},
      personalCommitment: {},
      problem: {},
      oportunity: {},
      commitments: [],
      pcommitments: [],
      objectives: [],
      tracing: null,
      listUserCommitments: { nuevos: [], pendientes: [] },
      listLeaderCommitments: { nuevos: [], pendientes: [] },
      listPersonalCommitments: { nuevos: [], pendientes: [] },
      listProblem: { nuevos: [], pendientes: [] },
      listOportunities: { nuevos: [], pendientes: [] },
      compromisocolab: false,
      compromisolider: false,
      compromisoper: false,
      problemas: false,
      oportunidades: false,
      comment: null,
      categories: [],
      subcategories: [],  
      clasificacion: ['Áreas de Soporte', 'Camioneta 5S', 'Elementos de Seguridad y EPP', 'Herramientas', 'Nada que declarar', 'Procedimientos Instalación/Mantención','Stock equipos'],
      responsables: [],
      type: null,
      comments: [],
      closing: null,
      item: { description: '', comments: [] }
    }
  },
  methods: {
    moment,
    ...mapActions('tracing', [
      'createProblemOrOportunity', 
      'getUserInformation', 
      'loadCommitmentsByUser', 
      'getPersonalCommitments', 
      'listProblems', 
      'deleteProblem',
      'finishTracing'
    ]),
    ...mapActions('commitment', [
      'addCommitmentToTracing', 
      'deleteCommitment', 
      'addCommentToCommitment', 
      'getCommentsFromCommitment',
      'closeCommitment'
    ]),
    ...mapActions('category', [ 'categoriesList' ]),
    ...mapActions('subcategory', [ 'byCategoryId' ]),
    ...mapActions('user', ['usersOfTeam']),
    ...mapActions('problem', [
      'addCommentToProblem', 
      'getCommentsFromProblem',
      'closeProblem'
    ]),
    getUser(id) {
      const vm = this;
      vm.getUserInformation(id).then(user => {
        vm.user = user
        const loadData = { userId: vm.user.users[0].id, tracingId: id, userLeader: vm.$store.state.auth.user.id}
        vm.loadCommitments(loadData)
        vm.responsables = [{
          id: vm.user.users[0].id,
          name: vm.user.users[0].name
        }, {
          id: vm.$store.state.auth.user.id,
          name: vm.$store.state.auth.user.name
        }]
      })
    },
    addCommitmentToCollab() {
      const vm = this;
      const { description, date } = vm.commitment;
      if (description && date) {
        const data = { 
          tracing: vm.$route.params.id,
          date: new Date(moment()),
          commitment: {
            scheduled: date,
            description,
            accountable: vm.user.users[0].id,
            created_by: vm.userLogged.id
          }
        }
        vm.addCommitmentToTracing(data).then(response => {
          if (response.success) {
            vm.listUserCommitments.nuevos.push(response.message)
            vm.commitment.description = ''
            vm.commitment.date = ''
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Compromiso de colaborador creado',
              closeable: true,
              duration: 5000
            })
          }
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe rellenar todos los campos',
          closeable: true,
          duration: 5000
        })
      }
    },
    addCommitmentToLeader() {
      const vm = this;
      const { id } = vm.$store.state.auth.user
      const { description, date } = vm.leaderCommitment
      if (description && date) {
        const data = { 
          tracing: vm.$route.params.id,
          date: new Date(moment()),
          commitment: {
            scheduled: date,
            description,
            accountable: id,
            created_by: vm.userLogged.id
          }
        }
        vm.addCommitmentToTracing(data).then(response => {
          if (response.success) {
            vm.leaderCommitment.description = ''
            vm.leaderCommitment.date = ''
            vm.listLeaderCommitments.nuevos.push(response.message)
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Compromiso de lider creado',
              closeable: true,
              duration: 5000
            })
          }
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe rellenar todos los campos',
          closeable: true,
          duration: 5000
        })
      }
    },
    getSubByCat() {
      const vm = this
      vm.byCategoryId(vm.personalCommitment.category._id).then(() => {
        vm.subcategories = vm.$store.getters['subcategory/getSubcategories']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    loadCommitments(data) {
      const vm = this
      vm.loadCommitmentsByUser(data)
      .then(commitments => {
        vm.listUserCommitments.nuevos = commitments.nuevos.filter(commitment => {
          return commitment.user._id == vm.user.users[0].id
        })
        vm.listUserCommitments.pendientes = commitments.pendientes.filter(commitment => {
          return commitment.user._id == vm.user.users[0].id
        })
      })
      data.type = 'oportunity'
      vm.listProblems(data)
      .then(oportunities => {
        vm.listOportunities = oportunities
      })
      data.type = 'problem'
      vm.listProblems(data)
      .then(problems => {
        vm.listProblem = problems
      })
      vm.loadCommitmentsByUser(data)
      .then(commitments => {
        vm.listLeaderCommitments.nuevos = commitments.nuevos.filter(commitment => {
          return commitment.user._id == vm.$store.state.auth.user.id
        })
        vm.listLeaderCommitments.pendientes = commitments.pendientes.filter(commitment => {
          return commitment.user._id == vm.$store.state.auth.user.id
        })
      })
    },
    newProblem() {
      const vm = this;
        if (vm.pResponsable && vm.problem.description && vm.pClasificacion && vm.problem.date) {
        const data = {
          responsible: vm.pResponsable.id,
          user: vm.user.users[0].id,
          tracing: vm.$route.params.id,
          description: vm.problem.description,
          date: vm.problem.date,
          clasification: vm.pClasificacion,
          type: 'problem'
        }
        vm.createProblemOrOportunity(data).then(result => {
          if (result._id) {
            vm.problem.description = ''
            vm.problem.date = ''
            vm.pClasificacion = null
            vm.pResponsable = null
            vm.listProblem.nuevos.push(result)
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Nuevo problema creado',
              closeable: true,
              duration: 5000
            })
          }
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe rellenar todos los campos',
          closeable: true,
          duration: 5000
        })
      }
    },
    newOportunity() {
      const vm = this;
      if (vm.oResponsable && vm.oportunity.description && vm.oClasificacion && vm.oportunity.date) {
        const data = {
          responsible: vm.oResponsable.id,
          user: vm.user.users[0].id,
          tracing: vm.$route.params.id,
          description: vm.oportunity.description,
          date: vm.oportunity.date,
          clasification: vm.oClasificacion,
          type: 'oportunity'
        }
        vm.createProblemOrOportunity(data).then(result => {
          if (result._id) {
            vm.listOportunities.nuevos.push(result)
            vm.oportunity.description = ''
            vm.oportunity.date = ''
            vm.oClasificacion = null
            vm.oResponsable = null
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Nueva oportunidad creada',
              closeable: true,
              duration: 5000
            })
          }
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe rellenar todos los campos',
          closeable: true,
          duration: 5000
        })
      }
    },
    removeCommit(type, id) {
      const vm = this;
      if (type === 'user') {
        vm.deleteCommitment(id).then(result => {
          if (result) {
            vm.listUserCommitments.nuevos = vm.listUserCommitments.nuevos.filter(commitment => {
              return commitment.id !== id
            })
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Compromiso eliminado',
              closeable: true,
              duration: 5000
            })
          }
        })      
      } else {
        vm.deleteCommitment(id).then(result => {
          if (result) {
            vm.listLeaderCommitments.nuevos = vm.listLeaderCommitments.nuevos.filter(commitment => {
              return commitment.id !== id
            })
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Compromiso eliminado',
              closeable: true,
              duration: 5000
            })
          }
        })
      }
    },
    removeProblem(type, id) {
      const vm = this;
      if (type === 'problem') {
        vm.deleteProblem(id).then(result => {
          if (result) {
            vm.listProblem.nuevos = vm.listProblem.nuevos.filter(problem => {
              return problem._id !== id
            })
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Problema eliminado',
              closeable: true,
              duration: 5000
            })
          }
        })
      } else {
        vm.deleteProblem(id).then(result => {
          if (result) {
            vm.listOportunities.nuevos = vm.listOportunities.nuevos.filter(oportunity => {
              return oportunity._id !== id
            })
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Oportunidad eliminado',
              closeable: true,
              duration: 5000
            })
          }
        })
      }
    },
    closeSD() {
      const vm = this;
      const data = {
        userId: vm.user.users[0]._id,
        tracingId: vm.$route.params.id,
        userLeader: vm.$store.state.auth.user.id
      }
      vm.finishTracing(data).then(result => {
        const loading = vm.$toast.loading('Cerrando seguimiento diario...')
        if (result.success) {
          setTimeout(() => {
            this.$router.push('/seguimiento-diario/id')
            loading.hide()
          }, 3000)
          vm.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Seguimiento diario cerrado',
            closeable: true,
            duration: 5000
          })
        }
      }).catch(e => {
        loading.hide()
        vm.$notify({  
          type: 'error',
          title: 'Error',
          content: 'Error al cerrar seguimiento diario',
          closeable: true,
          duration: 5000
        })
      })
    },
    getComments(id, type) {
      const vm = this
      vm.commenting = id
      vm.type = type
      switch (vm.type) {
        case 'commitment':
          vm.getCommentsFromCommitment(vm.commenting).then(response => {
            vm.comments = response.reverse()
          })
        break
        case 'personalCommitment':
          vm.getCommentsFromPersonalCommitment(vm.commenting).then(response => {
            vm.comments = response.reverse()
          })
        break
        case 'problem':
          vm.getCommentsFromProblem(vm.commenting).then(response => {
            vm.comments = response.reverse()
          })
        break
      }
    },
    createComment(comment) {
      const vm = this
      const data = {
        description: comment,
        _id: vm.commenting,
        user: vm.$store.state.auth.user.name
      }
      switch (vm.type) {
        case 'commitment':
          vm.addCommentToCommitment(data).then(response => {
            vm.comments = response.reverse()
          })
        break
        case 'personalCommitment':
          vm.addCommentToPersonalCommitment(data).then(response => {
            vm.comments = response.reverse()
          })
        break
        case 'problem':
          vm.addCommentToProblem(data).then(response => {
            vm.comments = response.reverse()
          })
        break
      }
      vm.comment = ''
    },
    openCloseModal(id, type, item) {
      const vm = this;
      vm.item = item
      vm.drawer = true
      vm.closing = id
      vm.type = type;
    },
    closeItem() {
      const vm = this;
      if (vm.cumplimiento === '') {
        vm.$notify({  
          type: 'danger',
          title: 'Error',
          content: 'Tiene que elegir si fue completado',
          closeable: true,
          duration: 5000
        })  
      } else {      
        const data = {
          accomplished: vm.cumplimiento,
          id: vm.closing,
        }
        switch (vm.type) {
          case 'collabCommitment':
            vm.closeCommitment(data).then(result => {
              if (result._id) {
                vm.$notify({  
                  type: 'success',
                  title: 'Notification',
                  content: 'Cierre de compromiso ejecutado',
                  closeable: true,
                  duration: 5000
                })  
              vm.listUserCommitments.pendientes = vm.listUserCommitments.pendientes.filter(commitment => {
                return commitment._id !== result._id
              })
              }
            })
            break
          case 'leaderCommitment':
            vm.closeCommitment(data).then(result => {
              if (result._id) {
                vm.$notify({  
                  type: 'success',
                  title: 'Notification',
                  content: 'Cierre de compromiso ejecutado',
                  closeable: true,
                  duration: 5000
                })  
                vm.listLeaderCommitments.pendientes = vm.listLeaderCommitments.pendientes.filter(commitment => {
                  return commitment._id !== result._id
                })
              }
            })
            break
          case 'problem':
            vm.closeProblem(data).then(result => { 
              if (result._id) {
                vm.$notify({  
                  type: 'success',
                  title: 'Notification',
                  content: 'Cierre de problema/oportunidad ejecutado',
                  closeable: true,
                  duration: 5000
                })  
                if (result.type === 'problem') {
                  vm.listProblem.pendientes = vm.listProblem.pendientes.filter(problem => {
                    return problem._id !== result._id
                  })
                } else {
                  vm.listOportunities.pendientes = vm.listOportunities.pendientes.filter(problem => {
                    return problem._id !== result._id
                  })
                }
              }
            })
            break
        }
        vm.drawer = false
        vm.cumplimiento = ''
      }
    }
  },
  watch: {
    drawer : function() {
      this.$parent.overlay = !this.$parent.overlay
      this.$emit('clase', this.$parent.overlay)
      const el = document.querySelector('.overlay')
      if (this.$parent.overlay) {
        el.classList.add('open')
      } else {
        el.classList.remove('open')
      }
    },
  },
  mounted() {
    const vm = this; 
    const tracingId = vm.$route.params.id;
    vm.userLogged = vm.$store.getters['auth/getUserInfo'];
    vm.getUser(tracingId)
    vm.categoriesList().then(() => {
      vm.categories = vm.$store.getters['category/getCategories']
    }, (error) => {
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })
  }
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/views/seguimiento-diario-ejecutar.vue